// 订单管理-->价格维护-->中英文
export const priceAgreementLocale = {
    'zhCN': {
        public: {
            whetherDelete: '确定删除？'
        },
        priceAgreement: {
            importTemplate: '产品价格协议模板下载',
            shipperName: '货主名称',
            customerProvinceCity: '客户省份/城市',
            provinceName: '省份',
            cityName: '城市',
            customerName: '客户名称',
            customerPHCode: 'PHCode',
            customerSAPCode: 'SAPCode',
            productMaterialGroup: '产品/分型',
            effectiveTime: '有效时间：',
            startOrEndTime: '起始截止时间段：',
            startTime: '起始日期',
            endTime: '截止日期',
            productReferred: '产品简称',
            materialGroup: '分型',
            price: '单价（元）',
            coefficientOfCompensation: '补偿系数',

            batchDelete: '批量删除',
            batchDeleteMessage: '确定批量删除价格协议？',

            batchDelayed: '批量延时',
            batchDelayedMessage: '确定批量延时价格协议？',

            batchShrink: '批量缩时',
            batchShrinkMessage: '确定批量缩时价格协议？',

            priceAgreementManagement: '产品价格协议维护',
            priceAgreementDetail: '产品价格协议明细',

            // 验证相关
            shipperNameEmpty: '货主名称不能为空',
            customerNameEmpty: '客户名称不能为空',
            productMaterialGroupEmpty: '产品/分型不能为空',
            numberEmpty: '请输入数字',
            priceValidate: '单价最多九位整数、两位小数',
            coefficientOfCompensationValidate: '补偿系数最多九位整数、四位小数',
            timeValidate: '请选择起始截止时间段',
            endTimeIsNotNull: '截止时间不能为空',
            deleteSalesPlanMessage: '删除后请处理产品价格已终止的销售计划',
            shrinkSalesPlanMessage: '缩时后请处理产品价格已终止的销售计划',
            dwCoefficientOfCompensationValidate: 'D&W补偿系数最多九位整数、四位小数'
        }
    },
    'enUS': {
        public: {
            whetherDelete: 'Confirm delete?'
        },
        priceAgreement: {
            importTemplate: 'Product price agreement template download',
            shipperName: 'Shipper Name',
            customerProvinceCity: 'Customer province/city',
            provinceName: 'Province',
            cityName: 'City',
            customerName: 'Clients name',
            customerPHCode: 'PHCode',
            customerSAPCode: 'SAPCode',
            productMaterialGroup: 'Product / Classification',
            effectiveTime: 'Term of validity',
            startOrEndTime: 'Start time & Stop time',
            startTime: 'Start time',
            endTime: 'Deadline',
            productReferred: 'Product short name',
            materialGroup: 'Material Group',
            price: 'Unit price (yuan)',
            coefficientOfCompensation: 'Compensation coefficient',
            batchDelete: 'BatchDelete',
            batchDeleteMessage: 'Determine bulk delete price agreement?',
            batchDelayed: 'BatchDelayed',
            batchDelayedMessage: 'Determine the batch delay price agreement?',
            batchShrink: 'BatchShrink',
            batchShrinkMessage: 'Determine the batch time-limited price agreement?',
            priceAgreementManagement: 'Product price agreement maintenance',
            priceAgreementDetail: 'Product price agreement details',
            // 验证相关
            shipperNameEmpty: 'The Shipper Name Cannot Be Empty',
            customerNameEmpty: 'Customer name cannot be empty',
            productMaterialGroupEmpty: 'Product/score cannot be empty',
            numberEmpty: 'Please key in numbers',
            priceValidate: 'Unit price up to nine-digit integer, two decimal places',
            coefficientOfCompensationValidate: 'Compensation coefficient up to nine-digit integer, four decimal places',
            timeValidate: 'Please select the starting deadline',
            endTimeIsNotNull: 'Deadline cannot be empty',
            deleteSalesPlanMessage: 'Please dispose of the sales plan whose product price has been terminated after deletion.',
            shrinkSalesPlanMessage: 'Please handle the sales plan whose product price has been terminated after the time has expired.',
            dwCoefficientOfCompensationValidate: 'D&W compensation coefficient up to nine-digit integer, four decimal places'
        }
    }
}
export default priceAgreementLocale



// WEBPACK FOOTER //
// ./src/locale/modules/priceAgreementLocale.js